import { render, staticRenderFns } from "./Library.vue?vue&type=template&id=fdafa564&scoped=true&"
import script from "./Library.vue?vue&type=script&lang=ts&"
export * from "./Library.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdafa564",
  null
  
)

export default component.exports